import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _object_spread_props(target, source) {
  source = source != null ? source : {};

  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var propTypes = {
  /**
  * The visual style of the Ordered List.
  * One of: "standard", "checkmark", "shaded", "minimal".
  */
  skin: PropTypes.oneOf(['standard', 'checkmark', 'shaded', 'minimal']),

  /**
  * The starting number of this Ordered List.
  */
  start: PropTypes.number
};
var OrderedList = createComponent({
  displayName: 'OrderedList',
  root: 'ol',
  propTypes: propTypes,
  propConfig: {
    classNames: function classNames(props) {
      var classNameSet = new Set(['swan-list']);
      var _props$skin = props.skin,
          skin = _props$skin === void 0 ? 'standard' : _props$skin;
      if (skin != 'standard') classNameSet.add("swan-list-skin-".concat(skin));
      return classNameSet;
    },
    processProps: function processProps(props) {
      return _object_spread_props(_object_spread({}, props), {
        style: _object_spread_props(_object_spread({}, props.style || {}), {
          '--swan-ordered-list-counter': props.start
        })
      });
    }
  }
});
OrderedList.defaultProps = {
  skin: 'standard'
};
export { OrderedList };